module.exports = new __parcel__URL__("star_wolvez_helmet_cosmetic.901b5a61.png").toString();